/* Ganesh Chaturthi landing page behaviour: tabs, ajax add to cart,
   saved-items hearts and the hero video modal.
   Written framework-free so it keeps working if Alpine is not ready yet,
   but it hands off to the Maximize cart drawer when that is available. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STORAGE_KEY = 'gnp:saved-products';

  /* ---------------------------------------------------------------- tabs */

  /* ------------------------------------------------------ community boxes */

  function initCommunityStages(section) {
    var stages = Array.prototype.slice.call(section.querySelectorAll('[data-gnp-community]'));

    stages.forEach(function (stage) {
      var home = stage.querySelector('[data-gnp-community-home]');
      var details = Array.prototype.slice.call(stage.querySelectorAll('[data-gnp-community-detail]'));
      var openers = Array.prototype.slice.call(stage.querySelectorAll('[data-gnp-community-open]'));
      if (!home || !details.length) return;

      function layout() {
        section.dispatchEvent(new CustomEvent('gnp:layout', { bubbles: false }));
      }

      function showHome() {
        home.hidden = false;
        details.forEach(function (detail) { detail.hidden = true; });
        layout();
      }

      function showDetail(id) {
        home.hidden = true;
        details.forEach(function (detail) {
          detail.hidden = detail.dataset.gnpCommunityDetail !== id;
        });
        layout();
      }

      openers.forEach(function (opener) {
        opener.addEventListener('click', function () {
          showDetail(opener.dataset.gnpCommunityOpen);
        });
      });

      stage.querySelectorAll('[data-gnp-community-back]').forEach(function (back) {
        back.addEventListener('click', showHome);
      });
    });
  }

  function initTabs(section) {
    /* Scoped per [role="tablist"] rather than one flat list per section, so
       a page can nest independent tab groups — e.g. a community picker with
       its own T-Shirts/Kurtas sub-filter inside each community — without
       every group fighting over which tab is "selected". */
    var groups = Array.prototype.slice.call(section.querySelectorAll('[role="tablist"]'));

    groups.forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-gnp-tab]'));
      if (!tabs.length) return;

      function select(target) {
        tabs.forEach(function (tab) {
          var isActive = tab === target;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          var panel = section.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !isActive;
        });

        /* a panel has no width while hidden, so every carousel inside it has to
           re-measure the moment its tab is opened */
        section.dispatchEvent(new CustomEvent('gnp:layout', { bubbles: false }));
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab);
        });
        tab.addEventListener('keydown', function (event) {
          var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          event.preventDefault();
          var next = tabs[(index + step + tabs.length) % tabs.length];
          next.focus();
          select(next);
        });
      });
    });
  }

  /* ---------------------------------------------------------- carousels */

  function initCarousels(section) {
    var carousels = Array.prototype.slice.call(section.querySelectorAll('[data-gnp-carousel]'));
    if (!carousels.length) return;

    var refreshers = [];

    carousels.forEach(function (root) {
      var track = root.querySelector('[data-gnp-track]');
      if (!track) return;

      var prev = root.querySelector('[data-gnp-prev]');
      var next = root.querySelector('[data-gnp-next]');
      var dotsWrap = root.querySelector('[data-gnp-dots]');
      var cards = Array.prototype.slice.call(track.children);
      if (cards.length < 2) return;

      var pages = 1;
      var current = 0;

      /* distance from one card's left edge to the next, gap included */
      function stride() {
        if (cards.length < 2) return Math.max(1, cards[0].offsetWidth);
        return Math.max(1, cards[1].offsetLeft - cards[0].offsetLeft);
      }

      function perView() {
        var visible = Math.round(track.clientWidth / stride());
        return Math.min(cards.length, Math.max(1, visible));
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function setArrows() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= maxScroll() - 2;
        var idle = maxScroll() <= 2;
        if (prev) {
          prev.disabled = atStart;
          prev.hidden = idle;
        }
        if (next) {
          next.disabled = atEnd;
          next.hidden = idle;
        }
      }

      function setActiveDot() {
        if (!dotsWrap) return;
        var dots = Array.prototype.slice.call(dotsWrap.children);
        dots.forEach(function (dot, index) {
          dot.setAttribute('aria-current', index === current ? 'true' : 'false');
        });
      }

      function syncFromScroll() {
        var page = maxScroll() > 2
          ? Math.round(track.scrollLeft / (stride() * perView()))
          : 0;
        current = Math.min(pages - 1, Math.max(0, page));
        setArrows();
        setActiveDot();
      }

      function goTo(page) {
        current = Math.min(pages - 1, Math.max(0, page));
        track.scrollTo({
          left: Math.min(maxScroll(), current * perView() * stride()),
          behavior: 'smooth'
        });
        setActiveDot();
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        if (pages < 2) return;
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'gnp-dot';
          dot.setAttribute('aria-label', 'Go to product group ' + (i + 1));
          dot.setAttribute('aria-current', 'false');
          dot.dataset.gnpDot = String(i);
          dotsWrap.appendChild(dot);
        }
      }

      function refresh() {
        if (!track.clientWidth) return;
        var wanted = Math.ceil(cards.length / perView());
        if (wanted !== pages || (dotsWrap && dotsWrap.children.length !== (wanted < 2 ? 0 : wanted))) {
          pages = wanted;
          buildDots();
        }
        syncFromScroll();
      }

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      if (dotsWrap) {
        dotsWrap.addEventListener('click', function (event) {
          var dot = event.target.closest('[data-gnp-dot]');
          if (dot) goTo(parseInt(dot.dataset.gnpDot, 10) || 0);
        });
      }

      track.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        goTo(current + step);
      });

      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncFromScroll, 90);
      }, { passive: true });

      /* images landing late change the card height, not the stride, but a
         slow-loading first image can still shift offsets */
      Array.prototype.slice.call(track.querySelectorAll('img')).forEach(function (img) {
        if (!img.complete) img.addEventListener('load', refresh, { once: true });
      });

      refreshers.push(refresh);
      refresh();
    });

    if (!refreshers.length) return;

    function refreshAll() {
      refreshers.forEach(function (fn) { fn(); });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refreshAll, 150);
    });

    section.addEventListener('gnp:layout', function () {
      window.requestAnimationFrame(refreshAll);
    });
  }

  /* -------------------------------------------------------- add to cart */

  /* See the matching note in ganesh-product.js: the theme's reLoad() never
     refreshes #CartDrawer itself, so we ask for the rendered sections in the
     add request and swap them in, the way the theme's product-form.js does. */
  function cartSectionsToRender() {
    var sections = [{ id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
    var drawer = document.querySelector('#CartDrawer');
    if (drawer && drawer.dataset.sectionId) {
      sections.push({ id: drawer.dataset.sectionId, selector: '#CartDrawer' });
    }
    return sections;
  }

  function applyCartSections(payload) {
    if (!payload || !payload.sections) return false;
    var swappedDrawer = false;

    cartSectionsToRender().forEach(function (section) {
      var target = document.querySelector(section.selector);
      var html = payload.sections[section.id];
      if (!target || !html) return;

      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!fresh) return;

      target.innerHTML = fresh.innerHTML;
      if (section.selector === '#CartDrawer') swappedDrawer = true;
    });

    return swappedDrawer;
  }

  function refreshThemeCart(payload) {
    var drawerIsFresh = applyCartSections(payload);

    try {
      if (window.Alpine && typeof Alpine.store === 'function') {
        var miniCart = Alpine.store('xMiniCart');
        var cartHelper = Alpine.store('xCartHelper');
        if (cartHelper && typeof cartHelper.updateCurrentCountItem === 'function') {
          cartHelper.updateCurrentCountItem();
        }
        if (miniCart) {
          if (drawerIsFresh) {
            if (typeof miniCart.handleOpen === 'function') miniCart.handleOpen();
          } else if (typeof miniCart.reLoad === 'function') {
            miniCart.reLoad(true);
          }
        }
      }
    } catch (error) {
      console.warn('[ganesh] cart drawer refresh skipped', error);
    }

    var eventName = (window.CART_EVENT && window.CART_EVENT.cartUpdate) || 'maximize:cart:updated';
    document.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: { isItemCountChanged: true }
    }));
  }

  function initAddToCart(section) {
    section.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-gnp-atc-form]');
      if (!form) return;

      event.preventDefault();

      var button = form.querySelector('[data-gnp-atc]');
      var note = form.querySelector('[data-gnp-note]');
      var idField = form.querySelector('[name="id"]');
      if (!idField || button.classList.contains('is-loading')) return;

      var originalLabel = button.querySelector('[data-gnp-atc-label]');
      var originalText = originalLabel ? originalLabel.textContent : '';

      button.classList.add('is-loading');
      if (note) {
        note.textContent = '';
        note.className = 'gnp-card__note';
      }
      if (originalLabel) originalLabel.textContent = button.dataset.addingText || 'Adding...';

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: idField.value, quantity: 1 }],
          sections: cartSectionsToRender().map(function (section) { return section.id; })
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error(result.data.description || result.data.message || 'Could not add to cart');
          }
          if (note) {
            note.textContent = button.dataset.addedText || 'Added to cart';
            note.className = 'gnp-card__note gnp-card__note--success';
          }
          refreshThemeCart(result.data);
        })
        .catch(function (error) {
          if (note) {
            note.textContent = error.message;
            note.className = 'gnp-card__note gnp-card__note--error';
          }
        })
        .finally(function () {
          button.classList.remove('is-loading');
          if (originalLabel) originalLabel.textContent = originalText;
          if (note) {
            window.setTimeout(function () {
              note.textContent = '';
              note.className = 'gnp-card__note';
            }, 4000);
          }
        });
    });
  }

  /* ------------------------------------------------------- saved items */

  function readSaved() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeSaved(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      /* private browsing, nothing to do */
    }
  }

  function initWishlist(section) {
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-gnp-wish]'));
    if (!buttons.length) return;

    var saved = readSaved();

    buttons.forEach(function (button) {
      var handle = button.dataset.gnpWish;
      button.setAttribute('aria-pressed', saved.indexOf(handle) > -1 ? 'true' : 'false');

      button.addEventListener('click', function () {
        var list = readSaved();
        var index = list.indexOf(handle);
        if (index > -1) {
          list.splice(index, 1);
          button.setAttribute('aria-pressed', 'false');
        } else {
          list.push(handle);
          button.setAttribute('aria-pressed', 'true');
        }
        writeSaved(list);
      });
    });
  }

  /* -------------------------------------------------------- video modal */

  function initVideoModal(section) {
    var trigger = section.querySelector('[data-gnp-video-open]');
    var modal = section.querySelector('[data-gnp-modal]');
    if (!trigger || !modal) return;

    var box = modal.querySelector('[data-gnp-modal-box]');
    var markup = box ? box.innerHTML : '';
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      if (box) box.innerHTML = markup;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = modal.querySelector('[data-gnp-modal-close]');
      if (close) close.focus();
    }

    function close() {
      modal.hidden = true;
      if (box) box.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    if (box) box.innerHTML = '';

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      open();
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-gnp-modal-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  /* ---------------------------------------------------------------- boot */

  function init(scope) {
    var sections = Array.prototype.slice.call((scope || document).querySelectorAll('[data-gnp-section]'));
    sections.forEach(function (section) {
      if (section.dataset.gnpReady === 'true') return;
      section.dataset.gnpReady = 'true';
      initCommunityStages(section);
      initTabs(section);
      initCarousels(section);
      initAddToCart(section);
      initWishlist(section);
      initVideoModal(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* re-run for sections the theme editor re-renders */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  /* exposed so ganesh-product.js can (re)build a carousel's arrows/dots
     after it swaps in cards that arrived later over AJAX (e.g. related
     products), since the page-load pass above ran before they existed */
  window.GaneshInitCarousels = initCarousels;
})();
